import { render, staticRenderFns } from "./gdnJoin.vue?vue&type=template&id=678b6b22&"
import script from "./gdnJoin.vue?vue&type=script&lang=js&"
export * from "./gdnJoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports